import { useEffect } from 'react';

const useLocalStorage = <T = any>(key: string, initialValue?: T): [
  (data: T) => void,
  () => T | null,
  () => void,
] => {
  const get = (): T | null => {
    const data = localStorage.getItem(key);

    if (!data) return null;

    try {
      return JSON.parse(data);
    } catch (e) {
      return null;
    }
  };

  const set = (data: T): void => {
    localStorage.setItem(key, JSON.stringify(data));
  };

  const remove = (): void => {
    localStorage.removeItem(key);
  };

  // If initial value is provided and not already set, set the initial value
  useEffect(() => {
    if (initialValue !== undefined && get() === null) {
      set(initialValue);
    }
  }, []);

  return [set, get, remove];
};

export default useLocalStorage;
